import React from "react"
import { APIPost } from "../../../API"
import { TraksConsumer } from "../../../traks"
import { UserForm } from "../../../c/UserForm"
import { Modal } from "reactstrap"
import { LL } from "../../../c/LL"

const AddUser = ({ meta, showAddUser, setShowAddUser }) => {
	const signupOnClick = (user) => {
		const urlPort = window.location.port;
		const liveURL = window.location.protocol + "//" + window.location.hostname + (urlPort ? ":" + urlPort : "") + LL("/createpassword");
		user.company_id = meta.company_id
		APIPost('users', { ...user, link: liveURL }).then((reply) => {
			if (reply.status === 201) {
				window.location.reload();
			} else if (reply.status === 202) {
				alert("User email already exists")
				console.log(reply)
			}
		}).catch(err => {
			console.log(err)
			alert("An error happened")
		});
	};

	const preSetUser = {
		company_id: meta.company_id,
		company_name: meta.name,
		username: '',
		name: '',
		email: '',
		screen_name: '',
		phone_number: '',
		roles: []
	}

	return (
		<>
			<Modal isOpen={showAddUser} toggle={() => setShowAddUser(!showAddUser)} className={"modals"}>
				<TraksConsumer>
					<UserForm
						signupOnClick={signupOnClick}
						preSetUser={preSetUser}
						roles={meta.roles}
						hideAddUser={() => setShowAddUser(false)}
					/>
				</TraksConsumer>
			</Modal>
		</>
	);
};


export { AddUser }
